var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuex-dropdown',_vm._b({attrs:{"vuex-getter":_vm.getter},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=_vm._n($$v)},expression:"localValue"}},'vuex-dropdown',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }